<template>
  <v-card>
    <h1 class="text-pagename text-xs-center">Wallet</h1>
    <walletTable/>
    <!-- :rider_wallet="rider_wallet" -->
  </v-card>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import walletTable from "@/components/back-office/Rider/Wallet/WalletTable";
export default {
  data() {
    return {};
  },
  components: {
    walletTable
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/"
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province
      },
      {
        text: "Rider",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/rider/riderinhouse"
        // href: '/weserve_admin_login/control/' + this.$route.params.province + '/rider/riderdashboard'
      },
      {
        text: "Wallet",
        disabled: true
      }
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
  created() {
    this.$store.dispatch("fetchCashRider/getRiderWallet");
  }
  // computed: {
  //     ...mapState({
  //         rider_wallet: state => state.fetchCashRider.rider_wallet
  //     })
  // }
};
</script>
